MarketReportsApp.Models.ReportBuilderPrimary = Backbone.Model.extend({
	url: function() {
		return "/api/reports/aggregationschedules/" + MarketReportsApp.Variables.aggregateID;
	}
});